import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const updateExpenseBudget = createAsyncThunk("updateExpenseBudget", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`expense/budget/update`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const ExpenseBudgetUpdateSlice = createSlice({
	name: "ExpenseBudgetUpdateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	//reset state
	reducers: {
		resetExpenseBudgetUpdateState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},	

	extraReducers: (builder) => {
		builder.addCase(updateExpenseBudget.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateExpenseBudget.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateExpenseBudget.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default ExpenseBudgetUpdateSlice.reducer;
export const { resetExpenseBudgetUpdateState } = ExpenseBudgetUpdateSlice.actions;
